import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MainLoaderService } from '@hal/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-not-found-page',
  imports: [TranslateModule, RouterLink],
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss'],
})
export class NotFoundPageComponent {
  constructor(private _mainLoaderService: MainLoaderService) {
    this._mainLoaderService.hideLoader();
  }
}
